import type { ServiceID } from './types';

export const SERVICE_WEIGHTS: Record<ServiceID, number> = {
  'static-residential-ipv4': 1,
  'static-datacenter-ipv4': 2,
  'dedicated-mobile': 3,
  'static-residential-ipv6': 4,
  'static-datacenter-ipv6': 5,
  'rotating-mobile': 6,
  'rotating-residential': 7,
  vpn: 8,
};
